import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-artist',
  templateUrl: './about-artist.component.html',
  styleUrls: ['./about-artist.component.css']
})
export class AboutArtistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
